import React, { useEffect, useState, useCallback } from "react";
import { withRouter, useLocation } from "react-router-dom";
import { Auth } from "aws-amplify";
import { connect, useDispatch } from "react-redux";
import { Input } from "reactstrap";
import { compose } from "redux";
import Socket from "socket";
import moment from "moment";
import _ from "lodash";

import * as gameAction from "redux/game/action";
import * as loaderAction from "redux/loader/action";
import * as paramsAction from "redux/gameParams/actions";
import * as sbsAction from "redux/sbs/action";
import * as challengesAction from "redux/challenges/action";
import { on_sign_in } from "shared/helpers/onSignIn";
import GameNotFoundModal from "shared/components/gameNotFoundModal";
import { handleJoinRoom } from "shared/helpers/joiningGame";
import { get_route_from_game_code } from "shared/helpers/get_route_from_game_code";
import { set_header_drop_down } from "redux/game/action";

const Homepage = (props) => {
  const search = useLocation().search;
  const dispatch = useDispatch();

  const [joinCode, setJoinCode] = useState("");
  const [invalidCode, setInvalidCode] = useState(false);
  const mobile_app = _.get(props, "gameReducer.mobile_app");
  const branchJoincode = _.get(props, "gameReducer.branchJoincode");
  const currentUser = _.get(props, "gameReducer.currentUser");
  const challenge_button = _.get(props, "challengesReducer.challenge_button");
  const [isMobileApp, setIsMobileApp] = useState(false);

  useEffect(() => {
    return Socket.addListener(
      "challenge-get",
      handle_challenge_get,
      handle_challenge_get_error
    );
  }, []);

  const handle_challenge_get = (res) => {
    if (res) {
      let filtered_challenges = res.user_challenges
        .filter(
          (item) =>
            !item.archived &&
            moment(item.start_date) < moment() &&
            moment(item.end_date).isSameOrAfter(moment().format("MM/DD/YYYY"))
        )
        .sort((a, b) => moment(a.end_date) - moment(b.end_date));

      !_.isEmpty(filtered_challenges)
        ? props.set_challenge_button(true)
        : props.set_challenge_button(false);
    }
    props.setIsLoading(false);
  };

  const handle_challenge_get_error = (err) => {
    props.setIsLoading(false);
  };

  useEffect(() => {
    if (!_.isEmpty(currentUser)) {
      props.setIsLoading(true);
      const data = {
        action: "challenge-get",
        table: ["userChallenges"],
        team_code: currentUser.team_code,
        user_id: currentUser.userId
        // team_code: "teamCode",
        // user_id: "1"
      };
      Socket.sendMessage(data);
    }
  }, [currentUser]);

  useEffect(() => {
    props.show_leave_game(false);
    props.set_has_answered(false);
    isMobileApp && !mobile_app && _.isEmpty(currentUser) && did_mount();
  }, [isMobileApp, mobile_app]);

  useEffect(() => {
    if (branchJoincode !== "" && !_.isEmpty(currentUser)) {
      joinActivityAction(branchJoincode);
      setJoinCode(branchJoincode);
      props.setBranchJoincode("");
    }
  }, [branchJoincode, JSON.stringify(currentUser)]);

  const did_mount = async () => {
    const joincode = new URLSearchParams(search).get("joincode") || null;
    props.setIsLoading(true);
    try {
      const data = await Auth.currentAuthenticatedUser({
        bypassCache: true
      });
      const sub_id = data.signInUserSession.idToken.payload["cognito:username"];
      await on_sign_in(sub_id, props.history, joincode);
    } catch (error) {
      if (error === "The user is not authenticated") {
        props.endGame(true);
        props.setCurrentUser({});
        props.history.replace("/signin");
      }
      props.setIsLoading(false);
    }
  };

  useEffect(() => {
    return Socket.addListener("get-room", on_get_room, log_on_error);
  }, []);
  useEffect(() => {
    return Socket.addListener("others", handle_others, log_on_error);
  }, []);
  useEffect(() => {
    return Socket.addListener("end-game", handle_end_game, end_game_error);
  }, []);
  useEffect(() => {
    return Socket.addListener("join-room", on_join_room, join_room_error);
  }, []);
  useEffect(() => {
    return Socket.addListener("join-session", on_join_session, join_room_error);
  }, []);
  useEffect(() => {
    return Socket.addListener(
      "join-game-viewer",
      on_joingame_viewer,
      log_on_error
    );
  }, []);

  useEffect(() => {
    let is_mobile_app;
    const joincode = new URLSearchParams(search).get("joincode");
    const userid = new URLSearchParams(search).get("userid");
    const user_name = decodeURI(new URLSearchParams(search).get("user_name"));
    const challenges = new URLSearchParams(search).get("challenges");
    const team_code = new URLSearchParams(search).get("team_code");
    // if userid is present as a query paramater then the app is called by the mobile-app
    if (userid) {
      props.set_mobile_app(true);
      if (!!user_name) {
        props.setCurrentUser({ userId: userid, userName: user_name });
      } else {
        props.setCurrentUser({ userId: userid });
      }
      is_mobile_app = true;
    } else {
      props.set_mobile_app(false);
      is_mobile_app = false;
    }
    if (team_code) {
      props.setCurrentUser({
        userId: userid,
        userName: user_name,
        team_code: team_code
      });
    }
    if (is_mobile_app) {
      if (joincode) {
        get_room({ joincode, userid, is_mobile_app });
      } else if (challenges) {
        handleChallengesClick();
      }
    } else if (joincode && joincode !== "" && !_.isEmpty(currentUser)) {
      setJoinCode(joincode);
      joinActivityAction(joincode);
    }
    setIsMobileApp(true);
  }, [search, JSON.stringify(currentUser)]);

  const handle_end_game = (res) => {
    props.endGame();
  };

  const end_game_error = (err) => {
    console.log("err: ", err);
  };

  const on_join_room = (res) => {
    const game_code = res.room.game_code;
    const branch_url = res.room.branch_url;
    if (get_route_from_game_code(game_code) === "slice" && !invalidCode) {
      props.setIsLoading(false);
      props.endGame();
      props.setSliceGameCode(branch_url);
    } else {
      props.setGameName(game_code);
      // if (game_code === "SBS") {
      //   props.getSubGameData({ gameName: game_code });
      // } else {
      //   props.getGameData({ gameName: game_code });
      // }
      props.getGameData({ gameName: game_code });
      handleJoinRoom(res, props.history);
    }
    props.setIsLoading(false);
  };

  const on_join_session = (res) => {
    props.history.push("/lobby");
    props.setIsLoading(false);
  };

  const join_room_error = (err) => {
    if (err.error == "User cannot join this game") {
      props.setSliceGameCode(err.branch_url);
    } else {
      setInvalidCode(true);
    }
    props.setIsLoading(false);
  };

  const handle_others = (res) => {
    if (res && res.room) {
      on_get_room(res);
    }
  };

  const log_on_error = (data) => {
    if (data?.action === "get-room" && data?.error) {
      props.setIsLoading(false);
      setInvalidCode(true);
    }
  };

  const on_get_room = async (res) => {
    if (res && res.room) {
      const userid = new URLSearchParams(search).get("userid");
      const game_code = res.room.game_code;
      const branch_url = res.room.branch_url;
      if (get_route_from_game_code(game_code) === "slice" && !invalidCode) {
        props.setIsLoading(false);
        props.endGame();
        props.setSliceGameCode(branch_url);
      } else {
        props.setGameName(game_code);
        // if (game_code === "SBS") {
        //   await props.getSubGameData({ gameName: game_code });
        // } else {
        //   await props.getGameData({ gameName: game_code });
        // }
        await props.getGameData({ gameName: game_code });
        if (!!userid) {
          let data = {
            action: "join-game-viewer",
            joinCode: res.room.join_code,
            userId: userid
          };
          Socket.sendMessage(data);
        } else {
          const route = get_route_from_game_code(game_code);
          props.setIsLoading(false);
          props.history.replace(route);
        }
      }
    } else {
      props.setIsLoading(false);
    }
  };

  const on_joingame_viewer = (res) => {
    if (res?.room) {
      const game_code = res.room.game_code;
      const route = get_route_from_game_code(game_code);
      props.history.replace(route);
    }
    props.setIsLoading(false);
  };

  const handleInputChange = (value) => {
    value.length < 7 && setJoinCode(value.toLocaleUpperCase().trim());
  };

  const get_room = ({ joincode }) => {
    props.setIsLoading(true);
    let data = {
      action: "get-room",
      joinCode: joincode
    };
    Socket.sendMessage(data);
  };

  const joinActivityAction = (code) => {
    dispatch(set_header_drop_down(false));

    if (code === "" || code.length < 5) {
      props.setIsLoading(false);
      setInvalidCode(true);
    } else {
      const data = {
        mobileWebsite: true,
        action: "join-room",
        joinCode: code,
        userId: currentUser.userId,
        name: currentUser.userName,
        profileImage:
          currentUser.picture ||
          "https://cdn.comedywire.com/images/default-profile-icon.png",
        promoCode: currentUser.team_code,
        promoDescription: currentUser.team_code_description,
        promoExpirationDate: currentUser.team_code_expiration_date
      };
      Socket.sendMessage(data);
      props.setIsLoading(true);
    }
  };

  const handleJoinActivity = useCallback(
    _.debounce((code) => joinActivityAction(code), 1000, {
      leading: true,
      trailing: false
    }),

    [currentUser]
  );

  const handleModalButtonClick = () => {
    invalidCode && setInvalidCode(false);
  };
  const handleChallengesClick = () => {
    props.history.push("/challenges");
  };

  return (
    <>
      {!mobile_app && !_.isEmpty(currentUser) && (
        <div className="midgame-joining">
          <h3 className="heading">Join an Activity</h3>
          <Input
            id="inputID"
            type="text"
            name="game_code"
            value={joinCode}
            autoComplete="off"
            className="form-control game-code"
            placeholder="Enter 5 Digit Game Code"
            onChange={(e) => handleInputChange(e.target.value)}
          />
          <button
            color="primary"
            className="join-btn"
            onClick={() => handleJoinActivity(joinCode)}
          >
            Join Activity!
          </button>
          {currentUser.team_code !== undefined && challenge_button && (
            <button
              color="primary"
              className="challenges-btn"
              onClick={handleChallengesClick}
            >
              Challenges
            </button>
          )}
          {invalidCode && (
            <GameNotFoundModal
              btn_text="Try Again"
              onPress={handleModalButtonClick}
              onClose={handleModalButtonClick}
              text="Code not found, please try again"
            />
          )}
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  challengesReducer: state.challengesReducer
});

const mapDispatchToProps = (dispatch) => {
  return {
    endGame: (data) => dispatch(gameAction.endGame(data)),
    setSliceGameCode: (data) => dispatch(gameAction.setSliceGameCode(data)),
    setGameName: (data) => dispatch(gameAction.setGameName(data)),
    set_user_challenges: (data) =>
      dispatch(challengesAction.set_user_challenges(data)),
    set_challenge_button: (data) =>
      dispatch(challengesAction.set_challenge_button(data)),
    set_mobile_app: (data) => dispatch(gameAction.set_mobile_app(data)),
    setCurrentUser: (data) => dispatch(gameAction.setCurrentUser(data)),
    setIsLoading: (data) => dispatch(loaderAction.setIsLoading(data)),
    getGameData: (data) => dispatch(paramsAction.getGameData(data)),
    getSubGameData: (data) => dispatch(paramsAction.getSubGameData(data)),
    show_leave_game: (data) => dispatch(gameAction.show_leave_game(data)),
    setBranchJoincode: (data) => dispatch(gameAction.setBranchJoincode(data)),
    set_has_answered: (data) => dispatch(sbsAction.set_has_answered(data))
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(Homepage);
